$(document).ready(function() {

  // Debugging

  var stopHoverClose = false;


  function isTouchDevice() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

  var touchScreen = isTouchDevice();

  console.log("Is Touchscreen?" + touchScreen);

  // Do a check to see if this is a touch device

  // Keep track of mouse location
  var inNav = false;

  // Keep track of active nav category
  var activeNav = 0;


  /* Function to manage dropdown status based on mouse conditions & dropdown t/f */
  var checkStatus = function(hasDropdown) {

    if (inNav == false && stopHoverClose == false) {
      $(".navigation-dropdown").hide();
      // Remove the active link class from the parent nav nav-item

      $(".nav-item").each(function() {
        $(this).children("a").removeClass("active-category");
      });
    }

    if(inNav == true && hasDropdown == "false" && stopHoverClose == false) {
      $(".navigation-dropdown").hide();
      $(".nav-item").each(function() {
        $(this).children("a").removeClass("active-category");
      });
    }

    if (inNav == true && hasDropdown == "true") {
      $(".navigation-dropdown").show();
      $(".nav-item").each(function() {
        $(this).children("a").removeClass("active-category");
      });
    }
  };

  /* Function to move active menu into the dropdown */
  var menuChange = function(navItem, hasTier2) {
      // Get nav-item sub container

      var subNav = navItem.children(".subnav-container");
      var defaultCategory = subNav.attr("data-default-category");

      // Reset nav container contents

      var navContents = $(".nav-contents");
      navContents.html("");

      // Move subnav into main container

      navContents.html(subNav.html());

      // Update link visibility based on defaultCategory

      updateLinkVisibility(defaultCategory);

      if(hasTier2 == "false") {
        // Show all children
        navContents.children(".subnav-links-col").children(".subnav-right-image").children("div").each(function() {
          $(this).show();
        });
      }
  };


  /* Function to remove active class from nav */
  var clearActiveCategory = function() {
    if(activeNav != 0) {
      activeNav.removeClass("active");
      activeNav = 0;
    }
  }


  /* Function to manage subnav links based on category of selected nav */

  var updateLinkVisibility = function(category) {
      // First, we need to hide all subnav links regardless of category

      var subnavLinks = $(".subnav-links-col");
      subnavLinks.children(".subnav-item-col").hide();

      // Now, we need to go loop through all of the children
      // and show matching category subnavLinks

      subnavLinks.children(".subnav-item-col").each(function() {

          var linkCategory = $(this).attr("data-category");
          if(category == linkCategory) {
            $(this).show();
          }

      });
  };


  /* Open dropdown nav when conditions are right */
if(touchScreen) {
  // DO touchscreen stuff
  $(".nav-item").each(function() {
    // Disable our a links - ONLY if there is a dropdown
    if($(this).attr("data-dropdown") == "true") {
      // Then disable the link
      $(this).children("a").css("pointer-events","none");
    }
    // Else it stays up - no need to over-ride control
  });

  $(".nav-item").on("click", function() {
    var hasDropdown = $(this).attr("data-dropdown");
    var hasTier2 = $(this).attr("data-tier2");
    inNav = true;
    checkStatus(hasDropdown);
    menuChange($(this), hasTier2);
    // Add hover text effect

    $(this).children("a").addClass("active-category")
  });
}
else {
  // Do desktop/mouse stuff
  $(".nav-item").on("mouseenter", function() {
    var hasDropdown = $(this).attr("data-dropdown");
    var hasTier2 = $(this).attr("data-tier2");
    inNav = true;
    checkStatus(hasDropdown);
    menuChange($(this), hasTier2);
    // Add hover text effect

    $(this).children("a").addClass("active-category")
  });
}


  /* Monitor mouse position in nav to close it */

  $(".navigation-master").on("mouseleave", function() {
    inNav = false;
    checkStatus();
  });


  /* Register category hover function for switching subnavs */

  $("body").on("mouseenter", ".category-link", function() {
    clearActiveCategory();
    activeNav = $(this);
    activeNav.addClass("active");
    var selectedCategory = activeNav.attr("data-category");
    console.log(selectedCategory);
    updateLinkVisibility(selectedCategory);

  });

  /* Commands to show/hide nav arrow on container hover */

  /* $("body").on("mouseenter",".image-nav", function() {
      $(this).children(".label-container").children("i").show(500,"linear");
  });

  $("body").on("mouseleave", ".image-nav", function() {
      $(this).children(".label-container").children("i").hide(500,"linear");
  }); */

  /* Handle image swapping for Collectiosn tab */

  $(".navigation-master").on("mouseover", ".nav-lifestyle", function() {
    console.log("hovered");
    // Grab our new image URL

    var imageURL = $(this).attr("data-imagecode");

    // Set our image viewer SRC

    $(".subnav-image-viewer").attr("src", imageURL);

  });


  /* Mobile Nav */

  $(".header-mobile-nav").on("click", function() {
      // Check current status

      if($(this).attr("data-visible") == "false") {
        $(".navigation-mobile").show();
        // Change icon
        $(this).children("i").removeClass("fa-bars");
        $(this).children("i").addClass("fa-times");
        // Update status
        $(this).attr("data-visible", "true");
      }
      else {
        $(".navigation-mobile").hide();
        // Change icon
        $(this).children("i").addClass("fa-bars");
        $(this).children("i").removeClass("fa-times");
        // Update status
        $(this).attr("data-visible", "false");

        // Close all open menus

        $(".category-sub-block").each(function() {
          $(this).slideUp();
          $(this).attr("data-visible", "false");
          $(this).parent().children(".category-dropdown").children("i").addClass("fa-plus");
          $(this).parent().children(".category-dropdown").children("i").removeClass("fa-minus");

          // Close any sub lists

          $(this).children(".category-nav-list").each(function() {
              $(this).slideUp();
              $(this).attr("data-visible", "false");
              $(this).parent().children("h2").children("i").removeClass("fa-minus");
              $(this).parent().children("h2").children("i").addClass("fa-plus");
          });
        });
      }
  });

  // Control segement clicks

  $(".category-dropdown").on("click", function() {
      // Get our sub block

      var subBlock = $(this).parent().children(".category-sub-block");
      var menuIcon = $(this).children("i");
      if(subBlock.attr("data-visible") == "false") {
        // Hide all other sub-menus, and change their parent icon back

        $(".category-sub-block").each(function() {
            // Hide it
            $(this).slideUp();
            $(this).attr("data-visible","false");
            // Make sure icon is now +
            $(this).parent().children(".category-dropdown").children("i").addClass("fa-plus");
            $(this).parent().children(".category-dropdown").children("i").removeClass("fa-minus");
        });

        // Show it
        subBlock.slideDown();
        subBlock.attr("data-visible", "true")
        menuIcon.removeClass("fa-plus");
        menuIcon.addClass("fa-minus");
      }
      else {
        subBlock.slideUp();
        subBlock.attr("data-visible", "false");
        menuIcon.removeClass("fa-minus");
        menuIcon.addClass("fa-plus");
      }
  });

  /* Handle low-tier nav */

  $(".category-sub-block-toggle").on("click", function() {
    // Check if the link cat is open

    var parentBlock = $(this).parent();
    var blockList = $(this).attr("data-for");
    var blockHeading = $(this);

    if($(blockList).attr("data-visible") == "false") {
      // Close all other categories, then open this one
      parentBlock.children(".category-nav-list").each(function() {
        // Slide up and mark as closed
        $(this).slideUp();
        $(this).attr("data-visible", "false");
        $(this).parent().children("h2").children("i").removeClass("fa-minus");
        $(this).parent().children("h2").children("i").addClass("fa-plus");
      });

      $(blockList).slideDown();
      $(blockList).attr("data-visible", "true");
      blockHeading.children("i").addClass("fa-minus");
      blockHeading.children("i").removeClass("fa-plus");
    }
    else {
      // Close this only
      $(blockList).slideUp();
      $(blockList).attr("data-visible", "false");
    }
  });
});
